const AdyenCheckout = require('@adyen/adyen-web');
const progress = require('../../../utils/progress');

let webComponent = null;
/**
 * Initialize the web component
 *
 * @param {Element} componentContainer - Web component container
 */
function initAdyenComponent(componentContainer) {
    const {clientKey, paymentMethodsResponse, environment, paymentMethodType} = componentContainer.dataset;
    const countryCode = $('html').attr('lang');
    let pmResponse;
    const cardDataForFraudCheck = {
        issuerBin: '',
        endDigits: '',
        brand: ''
    };
    const styleObject = {
        base: {
            textAlign: 'left'
        },
        placeholder: {
            textAlign: 'left',
            color: '#767676' // @grey-1 to achieve 4.5 contrast ratio
        }
    };
    try {
        pmResponse = JSON.parse(paymentMethodsResponse);
    } catch (e) {
        // Not showing this to the client
    }
    const resultInput = $(`#${componentContainer.id}-input`)[0];
    const fraudCheckDataInput = $('#js-adyen-component-fraud-check-input')[0];

    /**
     * Main handler for the component
     *
     * @param {Object} state - component state
     * @param {boolean} state.isValid - is the data valid
     * @param {Object} state.data - all the data we will need for subsequent call
     * @param {Object} _component - component itself
     */
    // eslint-disable-next-line no-unused-vars
    function handleOnChange(state, _component) {
        if (state.isValid) {
            resultInput.value = JSON.stringify(state.data);
            if (fraudCheckDataInput) {
                fraudCheckDataInput.value = JSON.stringify(cardDataForFraudCheck);
            }
        } else {
            resultInput.value = '';
        }
    }

    /**
     * Needed when 3ds2 is rendered in the same form
     *
     * @param {Object} _state - component state
     * @param {Object} _component - component itself
     */
    // eslint-disable-next-line no-unused-vars
    function handleOnAdditionalDetails(_state, _component) {
        // This won't get called because we don't render 3ds2 on this page
    }

    /**
     * Handle when input on field becomes valid/invalid event
     *
     * @param {Object} cardData - The data related to the card
     */
    function handleOnFieldValid(cardData) {
        // When the card number field becomes valid, store the last digits
        if (cardData && cardData.fieldType === 'encryptedCardNumber' && cardData.valid) {
            cardDataForFraudCheck.endDigits = cardData.endDigits;
        }
    }

    /**
     * Handle card brand change event
     *
     * @param {Object} brandData - Card brand data detected by Adyen
     */
    function handleOnBrand(brandData) {
        cardDataForFraudCheck.brand = brandData.brand;
    }

    /**
     * Handle card BIN change event
     *
     * @param {Object} binData - Card BIN data detected by Adyen
     */
    function handleOnBin(binData) {
        cardDataForFraudCheck.issuerBin = binData.binValue;
    }

    /**
     * In theory this can get called if something is wrong in the component itself
     * Making sure the user won't proceed by clearing the result
     *
     * @param {Object} _error - error
     */
    // eslint-disable-next-line no-unused-vars
    function onError(_error) {
        resultInput.value = '';
    }

    if (!pmResponse || !clientKey) {
        return;
    }
    if (countryCode === 'ar') {
        styleObject.placeholder.textAlign = 'right';
        styleObject.base.textAlign = 'right';
    }

    const configuration = {
        locale: window.Constants.LOCALE,
        environment, // change When you're ready to accept live payments, change the value to one of our live environments https://docs.adyen.com/online-payments/components-web#testing-your-integration.
        clientKey,
        paymentMethodsResponse: pmResponse,
        paymentMethodsConfiguration: {
            card: {
                styles: styleObject,
                onFieldValid: handleOnFieldValid,
                onBrand: handleOnBrand,
                onBinValue: handleOnBin
            },
            // Required to apply styling to stored cards.
            storedCard: {
                styles: styleObject
            }
        },
        showBrandsUnderCardNumber: false, // this is per docs but it doesn't work, hidden with styles instead
        onChange: handleOnChange,
        onAdditionalDetails: handleOnAdditionalDetails,
        onError
    };

    AdyenCheckout(configuration).then(checkout => {
        webComponent = checkout
            .create(paymentMethodType, {
                hasHolderName: true,
                holderNameRequired: true
            })
            .mount(componentContainer);
    });
}

/**
 * Run through js-adyen-components and init the components
 */
exports.init = () => {
    $('.js-adyen-component').each((_, container) => {
        initAdyenComponent(container);
    });
};
/**
 * @param {Event} event - click evt
 * @returns {boolean} - if true if the PM is component based and is handled
 */
exports.handleIfComponent = event => {
    const $selectedPaymentMethodRadio = $('.payment-method-options .payment-method-radio:checked');
    const $webComponentInput = $(`#js-adyen-component-${$selectedPaymentMethodRadio?.val?.()}-input`);
    if (!$webComponentInput?.length) {
        // this is not a web component PM
        return false;
    }
    if (!$webComponentInput.val()) {
        // nothing in the input means the form is invalid
        event.preventDefault();
        progress.hide();
        webComponent?.submit(); // triggering this will show the error messages
    }
    return true;
};
